<kendo-grid #kendoGrid
            [data]='gridWrapper.gridData'
            [loading]='gridWrapper.loading'
            [height]='(bodyHeight$|async) || 400'
            scrollable='virtual'
            rowHeight='54px'
            [skip]='gridWrapper.gridState.skip'
            [pageSize]='gridWrapper.gridState.take'
            kendoGridSelectBy='id'
            [selectedKeys]='gridWrapper.mySelection'
            [sortable]='true'
            [groupable]='true'
            [group]='gridWrapper.gridState.group'
            [isGroupExpanded]='isGroupExpanded'
            (groupCollapse)='toggleGroup($event)'
            (groupExpand)='toggleGroup($event)'
            [sort]='gridWrapper.gridState.sort'
            (groupChange)='gridWrapper.groupChanged($event)'
            (dataStateChange)='gridWrapper.onDataStateChange($event)'
            [reorderable]='true'
            [resizable]='true'
            filterable='menu'>

  <kendo-grid-messages
    [noRecords]="gridWrapper.loading ? '' : 'Aucun résultat'"
    filterClearButton='Effacer'
    filterFilterButton='Filtrer'
    groupPanelEmpty="Déplacer ici l'entête d'une colonne pour grouper...">
  </kendo-grid-messages>

  <ng-template kendoGridToolbarTemplate>
    <div class='flex-space-between'>
      <input #mainFilter placeholder='Rechercher...' kendoTextBox (input)='gridWrapper.onFilter($event.target)' />

      <button mat-icon-button
              color='primary'
              [style.visibility]="mainFilter.value.length > 0 ? 'visible' : 'hidden'"
              (click)="mainFilter.value=''; gridWrapper.clearFilter()">
        <mat-icon>clear</mat-icon>
      </button>

      <button *ngIf='config.item'
              mat-raised-button color='primary'
              style='margin-left:auto;'
              (click)='removeFilterByEs()'>
        Filter par l'ES {{config.item.idSegment}}
        <mat-icon>clear</mat-icon>
      </button>

      <button mat-icon-button (click)='reload()' matTooltip='Rafraîchir les données' class='refresh-button'>
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </ng-template>

  <kendo-grid-column field='numeroPgm' title='PGM' filterable='false' filterable='false'>
  </kendo-grid-column>

  <kendo-grid-column field='nomSousSysteme' title='Sous-système' filterable='false'>
  </kendo-grid-column>

  <kendo-grid-column field='nomEquipement' title='Equipement' filterable='false'>
  </kendo-grid-column>

  <kendo-grid-column field='descriptionCodeReponse' title='Code réponse'>
    <ng-template kendoGridFilterMenuTemplate
                 let-column='column'
                 let-filter='filter'
                 let-filterService='filterService'>

      <app-multicheck-filter
        [isPrimitive]='true'
        [field]='column.field'
        [filterService]='filterService'
        [currentFilter]='filter'
        [data]='distinctPrimitive(column.field)'
      ></app-multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field='progress' title='Progression' filterable='false'>
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class='flex-column'>
        <span>{{dataItem.dateFinEstimeeAsDate | date:'short'}}</span>
        <mat-progress-bar
          *ngIf='dataItem.dateFinEstimeeAsDate'
          mode='buffer'
          [value]='dataItem.progress'
          [bufferValue]='dataItem.progress + 5'>
        </mat-progress-bar>
      </div>
    </ng-template>
    <ng-template
      kendoGridGroupHeaderColumnTemplate
      let-aggregates='aggregates'>
      <mat-progress-bar
        *ngIf='aggregates?.progress?.min > -1'
        mode='buffer'
        [value]='aggregates?.progress?.min'
        [bufferValue]='aggregates?.progress?.min + 5'>
      </mat-progress-bar>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field='message' title='Message' filterable='false'>
  </kendo-grid-column>

</kendo-grid>
